var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$userInfo.isSystemAdministrator
    ? _c(
        "div",
        [
          _c("app-detail-header", {
            attrs: {
              "show-toggle": true,
              "show-add": true,
              "show-delete": false,
              "show-save": false,
              "show-print": false,
              "show-cancel": false,
            },
            on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
          }),
          _c("div", { staticClass: "columns is-gapless" }, [
            _c(
              "div",
              { staticClass: "column is-narrow" },
              [
                _c("company-list-side-menu", {
                  on: { filter: _vm.filterList, reset: _vm.resetList },
                  model: {
                    value: _vm.filter,
                    callback: function ($$v) {
                      _vm.filter = $$v
                    },
                    expression: "filter",
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "column" }, [
              _c("div", { staticClass: "m-3" }, [
                _c(
                  "article",
                  { staticClass: "box" },
                  [
                    _c(
                      "bulma-table",
                      {
                        staticClass:
                          "table is-bordered is-striped is-narrow is-fullwidth",
                        attrs: {
                          columns: _vm.columns,
                          "page-index": _vm.filter.pageIndex,
                          "page-size": _vm.filter.pageSize,
                          "total-rows": _vm.totalRows,
                          "is-loading": _vm.isTableLoading,
                          "sort-column": _vm.filter.sortColumn,
                          "sort-order": _vm.filter.sortOrder,
                        },
                        on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
                      },
                      [
                        _vm._l(_vm.entitySummaries, function (entity, index) {
                          return _c(
                            "tr",
                            {
                              key: entity.companyId,
                              class: {
                                "is-selected": _vm.selectedRow === index,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.highlightSelected(index, $event)
                                },
                              },
                            },
                            [
                              _c(
                                "td",
                                [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: {
                                          path: `${entity.companyId}/detail`,
                                        },
                                      },
                                    },
                                    [_vm._v(" " + _vm._s(entity.name) + " ")]
                                  ),
                                ],
                                1
                              ),
                              _c("td", [_vm._v(_vm._s(entity.abn))]),
                              _c("td", [_vm._v(_vm._s(entity.address))]),
                              _c("td", [_vm._v(_vm._s(entity.suburb))]),
                              _c("td", [_vm._v(_vm._s(entity.state))]),
                              _c("td", [_vm._v(_vm._s(entity.country))]),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatExpiryDate(entity.expiryDate)
                                  )
                                ),
                              ]),
                              _c("td", [_vm._v(_vm._s(entity.loginId))]),
                              _c("td", { staticClass: "has-text-centered" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "icon",
                                    class: [
                                      entity.isActive
                                        ? "has-text-success"
                                        : "has-text-danger",
                                    ],
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "mso mso-24px" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              entity.isActive
                                                ? "check"
                                                : "close"
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          )
                        }),
                        _c("template", { slot: "empty" }, [
                          _c("section", { staticClass: "section" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "content has-text-grey has-text-centered",
                              },
                              [
                                _c(
                                  "span",
                                  { attrs: { icon: "icon is-large" } },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "mso mso-fill mso-40px" },
                                      [_vm._v("sentiment_dissatisfied")]
                                    ),
                                  ]
                                ),
                                _c("p", [_vm._v("Nothing")]),
                              ]
                            ),
                          ]),
                        ]),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _c("company-new-modal", {
            attrs: { active: _vm.isNewCompanyModalActive },
            on: {
              close: function ($event) {
                _vm.isNewCompanyModalActive = false
              },
              create: _vm.handleCompanyCreate,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }